import { CSSObject } from '@mui/material';

import type { Theme } from '../../themes/themes';

export const createPillTheme = (theme: Theme): Partial<Theme> => ({
  components: {
    MuiChip: {
      styleOverrides: {
        root: {
          ...(theme.typography.button as CSSObject),
          textTransform: 'none',
          boxSizing: 'border-box',
          height: 'auto',
          borderRadius: '3em',
          border: 'none',
          boxShadow: `inset 0px 0px 0px 1px ${theme.palette.action.border}`,
          paddingTop: theme.spacing(3),
          paddingBottom: theme.spacing(3),
          paddingLeft: theme.spacing(5),
          paddingRight: theme.spacing(5),
          [theme.breakpoints.up('lg')]: {
            ...(theme.typography.button[theme.breakpoints.up('lg')] as CSSObject),
            paddingTop: theme.spacing(4),
            paddingBottom: theme.spacing(4),
            paddingLeft: theme.spacing(6),
            paddingRight: theme.spacing(6),
            lineHeight: '26px',
          },
          variants: [
            {
              props: {
                size: 'small',
              },
              style: {
                fontSize: 12,
                lineHeight: '16px',
                fontWeight: 400,
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(1),
                paddingLeft: theme.spacing(4),
                paddingRight: theme.spacing(4),
                [theme.breakpoints.up('lg')]: {
                  paddingTop: theme.spacing(1),
                  paddingBottom: theme.spacing(1),
                  paddingLeft: theme.spacing(4),
                  paddingRight: theme.spacing(4),
                },
              },
            },
            {
              props: {
                size: 'responsive',
              },
              style: {
                height: 0,
                fontSize: 10,
                lineHeight: '10px',
                fontWeight: 400,
                paddingBlockStart: theme.spacing(4),
                paddingBlockEnd: theme.spacing(4),
                paddingInlineStart: theme.spacing(1),
                paddingInlineEnd: theme.spacing(1),
                '& .MuiChip-avatarResponsive': {
                  color: 'inherit',
                  width: '10px',
                  height: '10px',
                  marginLeft: '4px',
                  marginRight: '-6px',
                  [theme.breakpoints.up('lg')]: {
                    width: '18px',
                    height: '18px',
                    marginLeft: 4,
                    marginRight: -6,
                  },
                },
                [theme.breakpoints.up('lg')]: {
                  fontSize: 16,
                  lineHeight: '26px',
                  fontWeight: 400,
                  paddingBlockStart: theme.spacing(6),
                  paddingBlockEnd: theme.spacing(6),
                  paddingInlineStart: theme.spacing(4),
                  paddingInlineEnd: theme.spacing(4),
                },
              },
            },
          ],
        },
        clickable: {
          cursor: 'pointer',
          '&:hover, [role=link]:hover a&': {
            borderColor: theme.palette.secondary.darker,
            backgroundColor: theme.palette.action.hover,
            boxShadow: `inset 0px 0px 0px 1px ${theme.palette.search.pills['outlineHover']}`,
          },
          '&:focus, [role=link]:focus a&': {
            backgroundColor: 'transparent',
            borderColor: theme.palette.action.focus,
            // boxShadow: `inset 0px 0px 0px 1px ${theme.palette.search.pills['outlineActive']}`,
            boxShadow: `inset 0px 0px 0px 1px ${theme.palette.border.hover}`,
          },
        },
        avatar: {
          color: 'inherit',
          width: '18px',
          height: '18px',
        },
        avatarSmall: {
          color: 'inherit',
          width: '10px',
          height: '10px',
          marginLeft: '4px',
          marginRight: '-6px',
        },
        deleteIcon: {
          color: 'inherit',
        },
      },
      defaultProps: {
        variant: 'outlined',
        color: 'default',
      },
    },
  },
});
